import { Bell } from 'lucide-react'
import * as React from 'react'

import { useNotifications } from './use-notifications'

/**
 * Sino do topo. O número é o de não lidas; o painel abre nas abas por tipo.
 * Clicar num aviso marca como lido e leva ao lugar (quadro com a atividade
 * aberta, nota, chamado).
 *
 * O painel (popover, lista, abas) vem sob demanda no primeiro clique — o sino
 * está em toda tela, e o popover com o posicionamento dele pesava no JS
 * inicial (Onda 6.2). Passar o mouse ou focar o sino já começa a baixar.
 */
const loadPanel = () => import('./NotificationPanel')
const NotificationPanel = React.lazy(loadPanel)

export function NotificationBell() {
  const { unread } = useNotifications()
  const [armed, setArmed] = React.useState(false)
  const [open, setOpen] = React.useState(false)

  if (!armed) {
    return (
      <BellButton
        unread={unread}
        onPointerEnter={() => void loadPanel()}
        onFocus={() => void loadPanel()}
        onClick={() => {
          setArmed(true)
          setOpen(true)
        }}
      />
    )
  }
  return (
    <React.Suspense fallback={<BellButton unread={unread} aria-busy />}>
      <NotificationPanel open={open} onOpenChange={setOpen} />
    </React.Suspense>
  )
}

export const BellButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { unread: number }
>(function BellButton({ unread, ...props }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={unread > 0 ? `Notificações: ${unread} não lida${unread === 1 ? '' : 's'}` : 'Notificações'}
      className="relative flex h-8 w-8 items-center justify-center rounded-md border border-border text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring data-[state=open]:bg-accent"
      {...props}
    >
      <Bell className="h-4 w-4" />
      {unread > 0 && (
        <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 font-mono text-[9px] font-semibold text-primary-foreground">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  )
})
